// extracted by mini-css-extract-plugin
module.exports = {"hallPos":"hallWithStands_hallPos__lz0ok","hallContainer":"hallWithStands_hallContainer__2uQgB"};